/* eslint-disable camelcase */
// eslint-disable-next-line camelcase
var ZCF_common;
(
  function (ZCF_common) {
    /**
     * 改变选中物体和未被选中物体的材质
     * @param objs 物体组
     * @param obj   选中物体
     * @param preObject 上一个选中物体
     * @param preMaterial   上一个物体材质
     * @param bool   未被选中的物体是否透明显示
     */
    ZCF_common.selectObj = function (objs, obj, pre, preinstallMat, bool, THREE) {
      if (pre.preObjs.length > 0) {
        for (var i = 0, len = pre.preObjs.length; i < len; i++) {
          pre.preObjs[i].material = pre.preMats[i]
        }
      }
      pre.preObjs = []
      pre.preMats = []
      if (bool) {
        objs.traverse(function (child) {
          if (child instanceof THREE.Mesh) {
            child.material.opacity = 0.2
          }
        })
      }
      if (obj.length) {
        for (let i = 0, len = obj.length; i < len; i++) {
          pre.preObjs.push(obj[i])
          pre.preMats.push(obj[i].material)
          obj[i].material = preinstallMat
        }
      } else {
        pre.preObjs.push(obj)
        pre.preMats.push(obj.material)
        obj.material = preinstallMat
      }
    }

    /**
     * 改变未被选中的物体的透明度
     * @param objs 物体组
     * @param obj   选中物体
     * @param bool   未被选中的物体是否透明显示
     */
    ZCF_common.changeUnselectedObjOpacity = function (objs, obj, bool, THREE) {
      if (obj.length > 0) {
        objs.traverse(function (child) {
          if (child instanceof THREE.Mesh && obj.indexOf(child) === -1) {
            if (bool) {
              child.material.opacity = 0.2
            } else {
              child.material.opacity = 1.0
            }
          }
        })
      } else {}
    }
    /**
     * 取消改变选中物体和未被选中物体的材质
     * @param objs 物体组
     * @param pre 之前保存的物体和材质数组
     */
    ZCF_common.cancelSelectObj = function (objs, pre) {
      console.log(pre)
      if (pre.preObjs.length > 0) {
        for (let i = 0, len = pre.preObjs.length; i < len; i++) {
          pre.preObjs[i].material = pre.preMats[i]
        }
        for (let i = 0, len = objs.children.length; i < len; i++) {
          objs.children[i].material.opacity = 1.0
        }
      }
      pre.preObjs = []
      pre.preMats = []
    }

    /**
     * 清除组中的子物体
     * @param group 组
     */
    ZCF_common.removeChildFromGroup = function (group) {
      for (var i = group.children.length - 1; i >= 0; i--) {
        group.children[i].geometry.dispose()
        group.children[i].material.dispose()
        group.remove(group.children[i])
      }
    }

    /**
     * 获取模型数据以后初始化相机和目标点位置，让模型渲染在画布中间
     * @param modelDate 模型的宽高深数据
     */
    ZCF_common.initCamera = function (camera, modelDate, controls) {
      camera.position.x = 0
      camera.position.y = modelDate.center.y
      camera.position.z = modelDate.r
      var target = modelDate.center.clone()
      controls.target = target

      controls.minDistance = modelDate.r * 0.5
      controls.maxDistance = modelDate.r * 1.5
    }

    /**
     * 获取导入的模型外包围的宽高深
     * @param model 需要获取的模型，可以为数组，或者单个模型，或者一个顶点的集合
     * @returns {{}}    返回一个json对象里面保存了模型的宽高深,分别为width,height,depth
     */
    ZCF_common.getModelDate = function (model, THREE) {
      var data = {}
      var box = new THREE.Box3()
      box.expandByObject(model)
      data.width = box.max.x - box.min.x
      data.height = box.max.y - box.min.y
      data.depth = box.max.z - box.min.z
      data.center = new THREE.Vector3(
        (box.min.x + box.max.x) / 2,
        (box.min.y + box.max.y) / 2,
        (box.min.z + box.max.z) / 2
      )
      data.r = Math.sqrt(data.width * data.width + data.height * data.height + data.depth * data.depth) * 1.0
      data.names = []
      model.traverse(function (child) {
        if (child instanceof THREE.Mesh) {
          data.names.push(child.name)
        }
      })
      return data
    }

    /*
     * 初始化右上角视角模型
     */
    ZCF_common.initViewModel = function (arr, textureLoad, THREE) {
      var group = new THREE.Group()
      var planeGeo = new THREE.PlaneBufferGeometry(100, 100)
      var arrowGeo = new THREE.CylinderBufferGeometry(1, 15, 30, 16, 1)
      for (var i = 0, len = arr.length; i < len; i++) {
        var plane = new THREE.Mesh(planeGeo.clone(), new THREE.MeshBasicMaterial({
          map: textureLoad.load(arr[i].url)
        }))
        plane.position.set(arr[i].pos01.x, arr[i].pos01.y, arr[i].pos01.z)
        plane.rotation.set(arr[i].rot01.x, arr[i].rot01.y, arr[i].rot01.z)
        plane.name = arr[i].name + 'Plane'
        group.add(plane)
        var arrow = new THREE.Mesh(arrowGeo.clone(), new THREE.MeshBasicMaterial({
          color: 0x666666,
          transparent: true
        }))
        arrow.position.set(arr[i].pos02.x, arr[i].pos02.y, arr[i].pos02.z)
        arrow.rotation.set(arr[i].rot02.x, arr[i].rot02.y, arr[i].rot02.z)
        arrow.name = arr[i].name + 'Arrow'
        group.add(arrow)
      }
      return group
    }
    /**
     * 通过半径,lon,lat,h来计算出对象的坐标
     * @param obj   需要计算坐标的对象
     * @param r     半径
     * @param lon   经度
     * @param lat   纬度
     * @param h     高度
     */
    ZCF_common.posObj = function (obj, r, lon, lat, h, THREE) {
      lat = Math.max(-89, Math.min(89, lat))
      var phi = THREE.Math.degToRad(90 - lat)
      var theta = THREE.Math.degToRad(lon)
      obj.position.x = -r * Math.sin(phi) * Math.cos(theta)
      obj.position.y = r * Math.cos(phi) + h
      obj.position.z = r * Math.sin(phi) * Math.sin(theta)
    }
    /**
     * 根据对象的渲染深度差改变模型透明度
     * @param model 需要改变透明度的模型组
     */
    ZCF_common.changeOpacity = function (model, viewCamera) {
      var uArrowPos = model.getObjectByName('uArrow').position.clone()
      uArrowPos.project(viewCamera)
      var dArrowPos = model.getObjectByName('dArrow').position.clone()
      dArrowPos.project(viewCamera)
      var USubD = Math.abs(uArrowPos.z - dArrowPos.z) / 0.32
      var lArrowPos = model.getObjectByName('lArrow').position.clone()
      lArrowPos.project(viewCamera)
      var rArrowPos = model.getObjectByName('rArrow').position.clone()
      rArrowPos.project(viewCamera)
      var LSubR = Math.abs(lArrowPos.z - rArrowPos.z) / 0.32
      var fArrowPos = model.getObjectByName('fArrow').position.clone()
      fArrowPos.project(viewCamera)
      var bArrowPos = model.getObjectByName('bArrow').position.clone()
      bArrowPos.project(viewCamera)
      var FSubB = Math.abs(fArrowPos.z - bArrowPos.z) / 0.32
      model.getObjectByName('uArrow').material.opacity = Math.max(0, Math.min(1, 1 - USubD * 2))
      model.getObjectByName('dArrow').material.opacity = Math.max(0, Math.min(1, 1 - USubD * 2))
      model.getObjectByName('lArrow').material.opacity = Math.max(0, Math.min(1, 1 - LSubR * 2))
      model.getObjectByName('rArrow').material.opacity = Math.max(0, Math.min(1, 1 - LSubR * 2))
      model.getObjectByName('fArrow').material.opacity = Math.max(0, Math.min(1, 1 - FSubB * 2))
      model.getObjectByName('bArrow').material.opacity = Math.max(0, Math.min(1, 1 - FSubB * 2))
    }

    // 清除场景
    ZCF_common.disposeCache = function (g) {
      if (g.material) {
        if (g.material instanceof Array) {
          for (var i in g.material) {
            if (g.material[i].map) g.material[i].map.dispose()
            g.material[i].dispose()
          }
        } else {
          if (g.material.map) {
            g.material.map.dispose()
          }
          g.material.dispose()
        }
      }
      if (g.geometry) {
        g.geometry.dispose()
      }
    }
    // 获取url
    ZCF_common.getQueryString = function (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      var r = window.location.search.substr(1).match(reg)
      if (r != null) {
        return decodeURI(r[2])
      }
      return null
    }
  }
)(ZCF_common || (ZCF_common = {}))

export default ZCF_common
